import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Alert,
  InputAdornment,
  IconButton,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { environmentDetails } from "../../environment/environment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userLoginActionFn } from "../../Redux/Auth/action";
import { roleModules } from "../../utils/getRoleModules";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenIcon from "@mui/icons-material/LockOpen";

const InputField = ({ isSessionExpired, setIsSessionExpired }) => {
  const [signinError, setSigninError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const login = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getColorTheme = JSON.parse(localStorage.getItem("colors")) || [];
  const primaryColor = getColorTheme[0]?.primaryColor || "#041c44";
  const secondaryColor = getColorTheme[0]?.secondaryColor || "#ff9900";

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { userid: "", password: "" },
  });

  const onSubmit = (data) => {
    dispatch(userLoginActionFn(data)).then(async (res) => {
      if (res.payload) {
        const roles = await roleModules.getModules();
        localStorage.setItem("iflowRoleList", JSON.stringify(roles));
        setTimeout(() => navigate("/openings_table"), 500);
      } else {
        setSigninError(true);
        reset();
        setTimeout(() => setSigninError(false), 2000);
      }
    });
  };

  return (
    <>
      <style>{`
        .inputField {
          width: 100%;
        }

        @media (min-width: 715px) {
          .inputField {
            width: 50%;
          }
          .logoshow {
            display: none;
            margin: 0 auto;
          }
        }

        @media (max-width: 715px) {
          .logoshow {
            display: flex;
            margin: 0 auto;
          }
        }
      `}</style>

      <Box
        className="inputField"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: "32px",
          paddingRight: "32px",
          rowGap: "16px",
        }}
      >
        {signinError && (
          <Alert severity="error">You are not authorized to login!</Alert>
        )}
        {isSessionExpired && (
          <Alert severity="info">Session expired. Please login again.</Alert>
        )}

        <Box sx={{ mt: { xs: 3, md: 6 }, width: "100%" }}>
          <img
            className="logoshow"
            src={environmentDetails.logoUrl}
            alt="Company Logo"
            style={{
              width: "100%",
              maxWidth: "280px",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>

        <Box sx={{ mt: 3, width: "100%" }}>
          <h1 style={{ fontFamily: "Poppins", fontWeight: 700, textAlign: "center" }}>Login</h1>

          <form
            onSubmit={handleSubmit(onSubmit)}
            style={{ width: "100%" }}
          >
            <Box
              sx={{
                alignItems: "center",
                padding: "8px 12px",
                borderRadius: "6px",
                width: "100%",
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Username"
                {...register("userid", { required: "Username required!" })}
                error={Boolean(errors.userid)}
                helperText={errors.userid?.message}
                sx={{
                  "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                  width: "100%",
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <i className="fa-regular fa-circle-user" style={{fontSize: "20px"}}></i>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                alignItems: "center",
                padding: "8px 12px",
                borderRadius: "6px",
                width: "100%",
              }}
            >
              <TextField
                variant="outlined"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                {...register("password", { required: "Password required!" })}
                error={Boolean(errors.password)}
                helperText={errors.password?.message}
                sx={{
                  "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                  width: "100%",
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <i className="fa-solid fa-lock" style={{fontSize: "20px"}}></i>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <i className="fa-regular fa-eye-slash " style={{fontSize: "20px"}}></i> : <i className="fa-regular fa-eye" style={{fontSize: "20px"}}></i>}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Button
              type="submit"
              variant="contained"
              sx={{
                mt: 4,
                width: "100%",
                height: "50px",
                borderRadius: "12px",
                backgroundColor: primaryColor,
                color: secondaryColor,
                fontWeight: 600,
                "&:hover": { backgroundColor: primaryColor },
              }}
            >
              Sign In
            </Button>
          </form>
        </Box>
      </Box>
    </>
  );
};

export default InputField;
